import { useComposerStore } from '../hooks/useComposerStore'
import type { CapabilityActions } from './capabilitySlice'

export const useSetMixedMediaCapabilityInputs =
  (): CapabilityActions['setMixedMediaCapabilityInputs'] =>
    useComposerStore((state) => state.setMixedMediaCapabilityInputs)
